import { render } from "./PartnerFooter.vue?vue&type=template&id=3d14999f&scoped=true"
import script from "./PartnerFooter.vue?vue&type=script&lang=js"
export * from "./PartnerFooter.vue?vue&type=script&lang=js"

import "./PartnerFooter.vue?vue&type=style&index=0&id=3d14999f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d14999f"]])

export default __exports__